<template>
  <div id="LoginStaff">
    <div class="login-page">
      <transition name="fade">
        <div v-if="!registerActive" class="wallpaper-login"></div>
      </transition>
      <div class="wallpaper-register"></div>

      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-8 mx-auto">
            <div
              id="login-card"
              v-if="!registerActive"
              class="card login"
              v-bind:class="{ error: emptyFields }"
            >
              <h1>เข้าสู่ระบบ</h1>
              <form class="form-group" @submit.prevent="login">
                <input
                  v-model="inputLogin.std_code"
                  type="text"
                  class="form-control input-style"
                  placeholder="รหัสผู้ใช้"
                  required
                />
                <input
                  v-model="inputLogin.password"
                  type="password"
                  class="form-control input-style"
                  placeholder="รหัสผ่าน"
                  required
                />
                <button
                  id="button"
                  type="submit"
                  class="btn btn-primary deep-purple btn-block"
                >
                  ยืนยัน
                </button>
                <!-- <input id="button" type="submit" class="btn btn-primary deep-purple btn-block" />  -->
                <p>
                  ยังไม่มีบัญชี
                  <a
                    href="#"
                    @click="
                      (registerActive = !registerActive), (emptyFields = false)
                    "
                    >ลงทะเบียน ที่นี่</a
                  >
                </p>
                <!-- <p><a href="#">Forgot your password?</a></p> -->
              </form>
            </div>

            <div
              id="regis-card"
              v-else
              class="card register"
              v-bind:class="{ error: emptyFields }"
            >
              <h1>ลงทะเบียน</h1>
              <form class="form-group" @submit.prevent="register">
                <input
                  v-model="inputReg.std_code"
                  type="text"
                  class="form-control input-style"
                  placeholder="รหัสผู้ใช้"
                  required
                />
                <input
                  v-model="inputReg.email"
                  type="email"
                  class="form-control input-style"
                  placeholder="อีเมล์"
                  required
                />

                <!--     
          <input class="form-control" id="password" type="password" v-model="Regpassword" required>
      
          <input class="form-control" id="password-confirm" type="password" v-model="password_confirmation" required> -->

                <!-- <input v-model="passwordReg" type="password" class="form-control" placeholder="Password" required>
                     <input v-model="confirmReg" type="password" class="form-control" placeholder="Confirm Password" required> -->
                <button
                  id="button"
                  type="submit"
                  class="btn btn-primary deep-purple btn-block"
                >
                  ยืนยัน
                </button>
                <p>
                  <!-- const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes -->
                  <!-- }) Already have an account? -->
                  <a
                    href="#"
                    @click="
                      (registerActive = !registerActive), (emptyFields = false)
                    "
                    >เข้าสู่ระบบ</a
                  >
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginStaff",
  data() {
    return {
      registerActive: false,
      emptyFields: false,
      secret_one: "",
      keycomponent: "",
      datas: "",
      timespit: "",
      token: "",
      access_token: "",
      ipAddress: "",
      inputReg: {
        std_code: "",
        email: "",
      },
      inputLogin: {
        std_code: "",
        password: "",
      },
    };
  },
  methods: {
    login() {
      let std_code = this.inputLogin.std_code;
      let password = this.inputLogin.password;
      this.$isLoading(true);
      this.$store
        .dispatch("login", { std_code, password })
        .then((res) => {
            if(localStorage.getItem("auth") !=null){
            this.auth = JSON.parse(localStorage.getItem("auth"))
            // console.log(this.auth.std_name);
          }

          if(res.msg.status != 200){
            this.$isLoading(false);
             this.message = res.msg.message
               
          }else{
             if (this.auth.isLibraryStaff === 1) {
            this.$isLoading(false);
            this.$router.push("/myjob");
            } else {
              this.$isLoading(false);
              this.$router.push("/");
            }
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style scoped>
#button {
  border-radius: 30px;
  background: #121414;
}

.input-style {
  border-radius: 30px;
  background-color: #ebf0fc;
  border-color: #ebf0fc;
  color: #9da3b0;
}
#login-card {
  width: 350px;
  border-radius: 25px;
  margin: 150px auto;
}
#regis-card {
  width: 350px;
  border-radius: 25px;
  margin: 150px auto;
}

p {
  line-height: 1rem;
}

.card {
  padding: 20px;
}

.form-group input {
  margin-bottom: 20px;
}
.form-group button {
  margin-bottom: 20px;
}

.login-page {
  align-items: center;
  display: flex;
  height: 100vh;
}
.login-page .wallpaper-login {
  /* background: url(https://www.solidbackgrounds.com/images/2732x2732/2732x2732-dark-pastel-purple-solid-color-background.jpg)
    no-repeat center center; */
  background: -webkit-linear-gradient(-55deg, #190b3a 40%, #121414 100%)
    no-repeat center center;
  background-size: cover;
  height: 100%;
  position: absolute;
  width: 100%;
}

.login-page .fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.wallpaper-register {
  /* background: url(https://www.solidbackgrounds.com/images/2732x2732/2732x2732-dark-pastel-purple-solid-color-background.jpg)
    no-repeat center center; */
  background-size: cover;
  background: -webkit-linear-gradient(-55deg, #190b3a 40%, #121414 100%)
    no-repeat center center;
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: -1;
}

h1 {
  margin-bottom: 1.5rem;
}

.error {
  animation-name: errorShake;
  animation-duration: 0.3s;
}

@keyframes errorShake {
  0% {
    transform: translateX(-25px);
  }
  25% {
    transform: translateX(25px);
  }
  50% {
    transform: translateX(-25px);
  }
  75% {
    transform: translateX(25px);
  }
  100% {
    transform: translateX(0);
  }
}
</style>
